module.exports = __webpack_public_path__ + "img/search-house.094b90ab.svg";